/**
 * Header logo destination by auth state and role (APP-440).
 *
 * Guest → consumer home `/` (the dashboard requires auth and would bounce
 * visitors to /login), customer → `/`, any other authenticated role →
 * partner dashboard `/dashboard`. Pure so the navigation contract test can
 * cover every auth-state × role combination without Nuxt context.
 */
export const resolveLogoLink = (isAuthenticated: boolean, isCustomerRole: boolean): string =>
  !isAuthenticated || isCustomerRole ? '/' : '/dashboard'
